import { apiDel, apiGet, apiPatch, apiPost } from "./helpers/api";
import { normalize, schema } from "normalizr";
import { notifySubmitError, notifySubmitSucceeded } from "./notifierProcesses";

const creditCardToken = new schema.Entity("creditCardTokens");

export function createCreditCardToken(dispatch, cardData) {
  // O token do recaptcha viaja fora do objeto `card` porque o backend o lê da
  // raiz dos params, enquanto `card_params` é um require(:card).permit(...).
  const { recaptchaToken, ...card } = cardData;

  return apiPost("/api/v1/credit_card_tokens").send({ card, recaptchaToken })
    .then((response) => {
      dispatch({
        type: "CREDIT_CARD_TOKEN_UPDATED",
        ...normalize(response.body.data, creditCardToken),
      });
      return response.body.data;
    });
  // Sem notificação aqui: os três modais que adicionam cartão já exibem o erro
  // dentro do próprio formulário, e o toast aparecia em duplicidade.
}

export function fetchCreditCardTokens(dispatch) {
  return apiGet("/api/v1/credit_card_tokens").then((response) => {
    dispatch({
      type: "CREDIT_CARD_TOKENS_FETCHED",
      ...normalize(response.body.data, [creditCardToken]),
    });
  });
}

export function setDefaultCreditCardToken(dispatch, tokenId) {
  return apiPatch(`/api/v1/credit_card_tokens/${tokenId}/set_default`)
    .then((response) => {
      dispatch({
        type: "CREDIT_CARD_TOKEN_UPDATED",
        ...normalize(response.body.data, creditCardToken),
      });

      notifySubmitSucceeded(dispatch, "Método de pagamento principal atualizado com sucesso!");
    })
    .catch((error) => {
      notifySubmitError(dispatch, {
        title: "Erro ao atualizar método principal",
        message: "Não foi possível definir este método como principal. Tente novamente.",
      });

      throw error;
    });
}

export function deleteCreditCardToken(dispatch, tokenId) {
  return apiDel(`/api/v1/credit_card_tokens/${tokenId}`)
    .then((response) => {
      dispatch({
        type: "CREDIT_CARD_TOKEN_DELETED",
        id: tokenId,
      });

      notifySubmitSucceeded(dispatch, "Método de pagamento excluído com sucesso!");
      return fetchCreditCardTokens(dispatch).then(() => response);
    })
    .catch((error) => {
      notifySubmitError(dispatch, {
        title: "Erro ao excluir método de pagamento",
        message: "Não foi possível excluir este método de pagamento. Tente novamente.",
      });

      throw error;
    });
}
